import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "className", "forceRender", "id", "selected", "selectedClassName"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import cx from "clsx";
var DEFAULT_CLASS = "react-tabs__tab-panel";
var defaultProps = {
  className: DEFAULT_CLASS,
  forceRender: false,
  selectedClassName: "".concat(DEFAULT_CLASS, "--selected")
};
var TabPanel = function TabPanel(props) {
  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
    children = _defaultProps$props.children,
    className = _defaultProps$props.className,
    forceRender = _defaultProps$props.forceRender,
    id = _defaultProps$props.id,
    selected = _defaultProps$props.selected,
    selectedClassName = _defaultProps$props.selectedClassName,
    attributes = _objectWithoutProperties(_defaultProps$props, _excluded);
  return React.createElement("div", Object.assign({}, attributes, {
    className: cx(className, _defineProperty({}, selectedClassName, selected)),
    role: "tabpanel",
    id: "panel".concat(id),
    "aria-labelledby": "tab".concat(id)
  }), forceRender || selected ? children : null);
};
TabPanel.tabsRole = "TabPanel";
export default TabPanel;